import { PaymentFieldType } from '@endeavour/payment-integration';
import { z } from 'zod';

function getSchemaFromFields(fields, isRepeatUsage) {
    if (!fields || fields.length === 0) {
        return;
    }
    const methodsSchema = fields.reduce((currentSchema, field) => {
        if (field.type === PaymentFieldType.CUSTOM) {
            currentSchema[field.name] = z.any();
            return currentSchema;
        }
        let schema = z.string();
        const validationType = isRepeatUsage ? 'repeatPayment' : 'newPayment';
        const requirements = field.validation[validationType];
        if (requirements.required) {
            schema = schema.min(1, `${field.name}.error.required`);
        }
        currentSchema[field.name] = schema;
        return currentSchema;
    }, {});
    return z.object(methodsSchema);
}

export { getSchemaFromFields };
